export const FILTER_DEFAULT_SKIP = 0
export const FILTER_DEFAULT_TAKE = 10
export const FILTER_DEFAULT_INFINITE_TAKE = 10
export const FILTER_TAKE_OPTIONS = [5, 10, 15, 20]

export const PAGINATION_PAGE_COUNT = 5

export const TRAFFIC_SIGNAL_STRENGTH_DEFAULT_TAKE = 30
